<template>
    <div class="text-generation">
      <h2>文本生成</h2>
      <el-input
        v-model="prompt"
        type="textarea"
        :rows="4"
        placeholder="输入提示词..."
      />
      <el-button type="primary" @click="generateText" :loading="loading">生成文本</el-button>
      <div v-if="generatedText" class="generated-content">
        <h3>生成结果：</h3>
        <p>{{ generatedText }}</p>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  
  const prompt = ref('')
  const generatedText = ref('')
  const loading = ref(false)
  
  const generateText = async () => {
    loading.value = true
    // 这里应该调用实际的 AI API
    await new Promise(resolve => setTimeout(resolve, 2000))
    generatedText.value = '这是一段由 AI 生成的示例文本。'
    loading.value = false
  }
  </script>
  
  <style scoped>
  .text-generation {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
  }
  
  .el-button {
    margin-top: 20px;
  }
  
  .generated-content {
    margin-top: 20px;
    padding: 20px;
    background-color: #1a1a1a;
    border-radius: 4px;
  }
  </style>